import { render, staticRenderFns } from "./view_dna.vue?vue&type=template&id=501b44e1&"
import script from "./view_dna.vue?vue&type=script&lang=js&"
export * from "./view_dna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports